import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import apiRuntime from '~/api/runtime';

type LastDeployConfigVariables = {
  realm: string;
  environment: string;
  pipelineName: string;
  versionMajor: number;
};

export const useLastDeployConfig = () => {
  const queryClient = useQueryClient();

  const fetchLastDeployConfig = useCallback(
    (variables: LastDeployConfigVariables) =>
      queryClient.fetchQuery({
        queryKey: [
          'run',
          'lastDeployConfig',
          variables.realm,
          variables.environment,
          variables.pipelineName,
          variables.versionMajor
        ],
        queryFn: () => apiRuntime.findByNameAndVersionMajor(variables),
        staleTime: 0,
        gcTime: 0
      }),
    [queryClient]
  );

  return { fetchLastDeployConfig };
};
